import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { apiRequest } from "../authConfig";

const PAGE_TITLES = {
    "/": "Dashboard",
    "/stores": "Stores",
    "/issues": "Issues",
    "/reports": "Reports",
    "/planograms": "Planograms",
    "/presets": "Presets",
    "/infrastructure": "Infrastructure",
    "/video-clips": "Video Clips",
    "/settings": "Settings",
};

function getPageTitle(path) {
    if (PAGE_TITLES[path]) return PAGE_TITLES[path];
    if (path.match(/^\/dip-form\/\d+/)) return "Dip Form";
    if (path.match(/^\/dip-form/)) return "Dip Form";
    if (path.match(/^\/dip-evidence/)) return "Dip Evidence";
    if (path.match(/^\/reviews\/dip\//)) return "Dip Review";
    if (path.match(/^\/store\/\d+\/hourly$/)) return "Hourly Images";
    if (path.match(/^\/store\/\d+\/issues$/)) return "Store Issues";
    if (path.match(/^\/store\/\d+\/reports$/)) return "Store Reports";
    if (path.match(/^\/store\/\d+/)) return "Store Detail";
    return path;
}

function extractSiteId(path) {
    const m = path.match(/\/store\/(\d+)/) || path.match(/\/dip-form\/(\d+)/);
    return m ? m[1] : null;
}

export default function usePageTracking() {
    const location = useLocation();
    const { accounts } = useMsal();
    const account = accounts[0];
    const lastPath = useRef(null);

    useEffect(() => {
        if (!account) return;
        const path = location.pathname;
        // Skip duplicate fires for the same path
        if (path === lastPath.current) return;
        lastPath.current = path;

        const payload = {
            userEmail: account.username,
            userName: account.name,
            pagePath: path,
            pageTitle: getPageTitle(path),
            siteId: extractSiteId(path),
        };

        // Fire and forget with auth token
        (async () => {
            try {
                const { instance } = await import("../index").then(m => ({ instance: m.msalInstance }));
                const accts = instance.getAllAccounts();
                let headers = { "Content-Type": "application/json" };
                if (accts.length > 0) {
                    try {
                        const tokenResp = await instance.acquireTokenSilent({ ...apiRequest, account: accts[0] });
                        headers.Authorization = `Bearer ${tokenResp.accessToken}`;
                    } catch {}
                }
                fetch("/api/v1/audit/pageview", {
                    method: "POST",
                    headers,
                    body: JSON.stringify(payload),
                }).catch(() => {});
            } catch {}
        })();
    }, [location.pathname, account]);
}
